import httpApi from '../../../hooks/api/httpApi';

type ApiKeyCheckResponseType = 'valid' | 'invalid';

const validateFoxpost = async (
    ecomId: number | null,
    testMode: boolean,
    username: string,
    password: string,
    api_key: string
): Promise<boolean> => {
    if (!ecomId) return Promise.reject();
    const res = await httpApi.post<ApiKeyCheckResponseType>(`/api/ecom/${ecomId}/api-key-validation/foxpost`, {
        testMode,
        username,
        password,
        api_key,
    });
    return res.getData() === 'valid';
};

const validateGls = async (
    ecomId: number | null,
    testMode: boolean,
    username: string,
    password: string,
    country?: string
): Promise<boolean> => {
    if (!ecomId) return Promise.reject();
    const res = await httpApi.post<ApiKeyCheckResponseType>(`/api/ecom/${ecomId}/api-key-validation/gls`, {
        testMode,
        username,
        password,
        country,
    });
    return res.getData() === 'valid';
};

const validateDpd = async (ecomId: number, username: string, password: string): Promise<boolean> => {
    const res = await httpApi.post<ApiKeyCheckResponseType>(`/api/ecom/${ecomId}/api-key-validation/dpd`, {
        username,
        password,
    });
    return res.getData() === 'valid';
};

const validateMpl = async (
    ecomId: number | null,
    testMode: boolean,
    api_key: string,
    accounting_code: string,
    agreement_code: string
): Promise<boolean> => {
    if (!ecomId) return Promise.reject();
    const res = await httpApi.post<ApiKeyCheckResponseType>(`/api/ecom/${ecomId}/api-key-validation/mpl`, {
        testMode,
        api_key,
        accounting_code,
        agreement_code,
    });
    return res.getData() === 'valid';
};

const validatePacketa = async (
    ecomId: number,
    testMode: boolean,
    api_key: string,
    api_password: string
): Promise<boolean> => {
    const res = await httpApi.post<ApiKeyCheckResponseType>(`/api/ecom/${ecomId}/api-key-validation/packeta`, {
        testMode,
        api_key,
        api_password,
    });
    return res.getData() === 'valid';
};

//TODO: add tourmix api key validation
const validateTourmix = async (ecomId: number, api_token: string, testMode: boolean): Promise<boolean> => {
    const res = await httpApi.post<ApiKeyCheckResponseType>(`/api/ecom/${ecomId}/api-key-validation/tourmix`, {
        api_token,
        testMode,
    });
    return res.getData() === 'valid';
};

export default {
    validateFoxpost,
    validateMpl,
    validateGls,
    validatePacketa,
    validateDpd,
    validateTourmix,
};
